<!-- Center canvas: summary, text typed into directly - whole card is one pinnable region -->
<div class="cr-x3-card" *ngIf="isPreview" [id]="block.blockId">
  <span class="cr-x3-badge">Inspiration + 3x Photo</span>

  <div class="cr-x3-grid">
    <div class="cr-x3-item">
      <div
        class="cr-x3-dropzone"
        [appInlineMedia]="block.variables?.['X3Exp1Image']"
        [inlineMediaBlockId]="block.blockId"
        (inlineMediaChange)="onChange($event, 'X3Exp1Image')"
      >
        <a *ngIf="block.variables?.['X3Exp1Image']; else empty1" [href]="card1ImageHref" target="_blank" rel="noopener">
          <img [src]="block.variables?.['X3Exp1Image']" [alt]="block.variables?.['X3Exp1ImageAlt'] || ''" />
        </a>

        <ng-template #empty1>
          <div class="cr-inline-media-icon">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
              <path d="M12 19.2V11.7" />
              <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
            </svg>
          </div>
          <div class="cr-inline-media-title">Upload image</div>
          <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
        </ng-template>
      </div>

      <span
        class="cr-x3-heading"
        [appInlineEdit]="block.variables?.X3Exp1Heading ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert heading"
        (inlineEditChange)="onChange($event, 'X3Exp1Heading')"
      ></span>

      <a class="cr-x3-cta" [href]="card1CtaHref" target="_blank" rel="noopener">
        <span
          [appInlineEdit]="block.variables?.X3Exp1CtaText ?? ''"
          [inlineEditBlockId]="block.blockId"
          [inlineEditPlaceholder]="ctaButtonPlaceholder"
          (inlineEditChange)="onChange($event, 'X3Exp1CtaText')"
        ></span>
      </a>
    </div>

    <div class="cr-x3-item">
      <div
        class="cr-x3-dropzone"
        [appInlineMedia]="block.variables?.['X3Exp2Image']"
        [inlineMediaBlockId]="block.blockId"
        (inlineMediaChange)="onChange($event, 'X3Exp2Image')"
      >
        <a *ngIf="block.variables?.['X3Exp2Image']; else empty2" [href]="card2ImageHref" target="_blank" rel="noopener">
          <img [src]="block.variables?.['X3Exp2Image']" [alt]="block.variables?.['X3Exp2ImageAlt'] || ''" />
        </a>

        <ng-template #empty2>
          <div class="cr-inline-media-icon">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
              <path d="M12 19.2V11.7" />
              <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
            </svg>
          </div>
          <div class="cr-inline-media-title">Upload image</div>
          <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
        </ng-template>
      </div>

      <span
        class="cr-x3-heading"
        [appInlineEdit]="block.variables?.X3Exp2Heading ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert heading"
        (inlineEditChange)="onChange($event, 'X3Exp2Heading')"
      ></span>

      <a class="cr-x3-cta" [href]="card2CtaHref" target="_blank" rel="noopener">
        <span
          [appInlineEdit]="block.variables?.X3Exp2CtaText ?? ''"
          [inlineEditBlockId]="block.blockId"
          [inlineEditPlaceholder]="ctaButtonPlaceholder"
          (inlineEditChange)="onChange($event, 'X3Exp2CtaText')"
        ></span>
      </a>
    </div>

    <div class="cr-x3-item">
      <div
        class="cr-x3-dropzone"
        [appInlineMedia]="block.variables?.['X3Exp3Image']"
        [inlineMediaBlockId]="block.blockId"
        (inlineMediaChange)="onChange($event, 'X3Exp3Image')"
      >
        <a *ngIf="block.variables?.['X3Exp3Image']; else empty3" [href]="card3ImageHref" target="_blank" rel="noopener">
          <img [src]="block.variables?.['X3Exp3Image']" [alt]="block.variables?.['X3Exp3ImageAlt'] || ''" />
        </a>

        <ng-template #empty3>
          <div class="cr-inline-media-icon">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
              <path d="M12 19.2V11.7" />
              <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
            </svg>
          </div>
          <div class="cr-inline-media-title">Upload image</div>
          <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
        </ng-template>
      </div>

      <span
        class="cr-x3-heading"
        [appInlineEdit]="block.variables?.X3Exp3Heading ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert heading"
        (inlineEditChange)="onChange($event, 'X3Exp3Heading')"
      ></span>

      <a class="cr-x3-cta" [href]="card3CtaHref" target="_blank" rel="noopener">
        <span
          [appInlineEdit]="block.variables?.X3Exp3CtaText ?? ''"
          [inlineEditBlockId]="block.blockId"
          [inlineEditPlaceholder]="ctaButtonPlaceholder"
          (inlineEditChange)="onChange($event, 'X3Exp3CtaText')"
        ></span>
      </a>
    </div>
  </div>
</div>

<!-- Right panel: real edit form - three identical field groups, one per card -->
<div class="cr-x3-edit" *ngIf="!isPreview">
  <div class="cr-x3-edit-card">
    <div class="cr-x3-edit-card-title">Card 1</div>

    <div class="cr-x3-field-row">
      <span class="cr-x3-field-label">Image</span>
      <span
        class="cr-x3-toggle"
        [class.cr-x3-toggle-on]="image1AsUpload"
        role="button"
        tabindex="0"
        [title]="image1AsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
        (click)="toggleImage1Mode()"
        (keydown.enter)="toggleImage1Mode()"
        (keydown.space)="toggleImage1Mode()"
      ></span>
    </div>
    <div class="cr-x3-image-field">
      <app-block-text
        [maxLength]="500"
        type="link"
        [blockData]="block.variables?.['X3Exp1Image'] ?? ''"
        (handleOnChange)="onChange($event, 'X3Exp1Image')"
        [placeholder]="image1Placeholder"
        variable="X3Exp1Image"
        [isImage]="image1AsUpload"
        [isPlainText]="true"
        [blockId]="block.blockId"
      ></app-block-text>
      <div class="cr-x3-empty-overlay" *ngIf="image1AsUpload && !block.variables?.['X3Exp1Image']">
        <div class="cr-x3-icon">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-x3-title">Upload image</div>
        <div class="cr-x3-subtitle">PNG up to 2 mb</div>
      </div>
    </div>

    <div class="cr-x3-link-field">
      <app-field-editor-v2
        [maxLength]="500"
        type="action-link"
        [blockData]="block.variables?.['X3Exp1ImageHref'] ?? ''"
        (handleOnChange)="onChange($event, 'X3Exp1ImageHref')"
        [placeholder]="image1HrefPlaceholder"
        variable="X3Exp1ImageHref"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'X3Exp1ImageHrefSegmentRegex')"
        [selectedSegment]="block.variables?.['X3Exp1ImageHrefSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="alt"
      [blockData]="block.variables?.['X3Exp1ImageAlt'] ?? ''"
      (handleOnChange)="onChange($event, 'X3Exp1ImageAlt')"
      [placeholder]="image1AltPlaceholder"
      [maxLength]="500"
      variable="X3Exp1ImageAlt"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X3Exp1Heading'] ?? ''"
      (handleOnChange)="onChange($event, 'X3Exp1Heading')"
      [placeholder]="heading1Placeholder"
      [maxLength]="500"
      variable="X3Exp1Heading"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <div class="cr-x3-link-field">
      <app-field-editor-v2
        type="action-link"
        [blockData]="block.variables?.['X3Exp1CtaLink'] ?? ''"
        (handleOnChange)="onChange($event, 'X3Exp1CtaLink')"
        [placeholder]="ctaLink1Placeholder"
        [maxLength]="500"
        variable="X3Exp1CtaLink"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'X3Exp1CtaLinkSegmentRegex')"
        [selectedSegment]="block.variables?.['X3Exp1CtaLinkSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X3Exp1CtaText'] ?? ''"
      (handleOnChange)="onChange($event, 'X3Exp1CtaText')"
      [placeholder]="ctaText1Placeholder"
      [maxLength]="30"
      variable="X3Exp1CtaText"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <div class="cr-x3-edit-card">
    <div class="cr-x3-edit-card-title">Card 2</div>

    <div class="cr-x3-field-row">
      <span class="cr-x3-field-label">Image</span>
      <span
        class="cr-x3-toggle"
        [class.cr-x3-toggle-on]="image2AsUpload"
        role="button"
        tabindex="0"
        [title]="image2AsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
        (click)="toggleImage2Mode()"
        (keydown.enter)="toggleImage2Mode()"
        (keydown.space)="toggleImage2Mode()"
      ></span>
    </div>
    <div class="cr-x3-image-field">
      <app-block-text
        [maxLength]="500"
        type="link"
        [blockData]="block.variables?.['X3Exp2Image'] ?? ''"
        (handleOnChange)="onChange($event, 'X3Exp2Image')"
        [placeholder]="image2Placeholder"
        variable="X3Exp2Image"
        [isImage]="image2AsUpload"
        [isPlainText]="true"
        [blockId]="block.blockId"
      ></app-block-text>
      <div class="cr-x3-empty-overlay" *ngIf="image2AsUpload && !block.variables?.['X3Exp2Image']">
        <div class="cr-x3-icon">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-x3-title">Upload image</div>
        <div class="cr-x3-subtitle">PNG up to 2 mb</div>
      </div>
    </div>

    <div class="cr-x3-link-field">
      <app-field-editor-v2
        [maxLength]="500"
        type="action-link"
        [blockData]="block.variables?.['X3Exp2ImageHref'] ?? ''"
        (handleOnChange)="onChange($event, 'X3Exp2ImageHref')"
        [placeholder]="image2HrefPlaceholder"
        variable="X3Exp2ImageHref"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'X3Exp2ImageHrefSegmentRegex')"
        [selectedSegment]="block.variables?.['X3Exp2ImageHrefSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="alt"
      [blockData]="block.variables?.['X3Exp2ImageAlt'] ?? ''"
      (handleOnChange)="onChange($event, 'X3Exp2ImageAlt')"
      [placeholder]="image2AltPlaceholder"
      [maxLength]="500"
      variable="X3Exp2ImageAlt"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X3Exp2Heading'] ?? ''"
      (handleOnChange)="onChange($event, 'X3Exp2Heading')"
      [placeholder]="heading2Placeholder"
      [maxLength]="500"
      variable="X3Exp2Heading"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <div class="cr-x3-link-field">
      <app-field-editor-v2
        type="action-link"
        [blockData]="block.variables?.['X3Exp2CtaLink'] ?? ''"
        (handleOnChange)="onChange($event, 'X3Exp2CtaLink')"
        [placeholder]="ctaLink2Placeholder"
        [maxLength]="500"
        variable="X3Exp2CtaLink"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'X3Exp2CtaLinkSegmentRegex')"
        [selectedSegment]="block.variables?.['X3Exp2CtaLinkSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X3Exp2CtaText'] ?? ''"
      (handleOnChange)="onChange($event, 'X3Exp2CtaText')"
      [placeholder]="ctaText2Placeholder"
      [maxLength]="30"
      variable="X3Exp2CtaText"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <div class="cr-x3-edit-card">
    <div class="cr-x3-edit-card-title">Card 3</div>

    <div class="cr-x3-field-row">
      <span class="cr-x3-field-label">Image</span>
      <span
        class="cr-x3-toggle"
        [class.cr-x3-toggle-on]="image3AsUpload"
        role="button"
        tabindex="0"
        [title]="image3AsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
        (click)="toggleImage3Mode()"
        (keydown.enter)="toggleImage3Mode()"
        (keydown.space)="toggleImage3Mode()"
      ></span>
    </div>
    <div class="cr-x3-image-field">
      <app-block-text
        [maxLength]="500"
        type="link"
        [blockData]="block.variables?.['X3Exp3Image'] ?? ''"
        (handleOnChange)="onChange($event, 'X3Exp3Image')"
        [placeholder]="image3Placeholder"
        variable="X3Exp3Image"
        [isImage]="image3AsUpload"
        [isPlainText]="true"
        [blockId]="block.blockId"
      ></app-block-text>
      <div class="cr-x3-empty-overlay" *ngIf="image3AsUpload && !block.variables?.['X3Exp3Image']">
        <div class="cr-x3-icon">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-x3-title">Upload image</div>
        <div class="cr-x3-subtitle">PNG up to 2 mb</div>
      </div>
    </div>

    <div class="cr-x3-link-field">
      <app-field-editor-v2
        [maxLength]="500"
        type="action-link"
        [blockData]="block.variables?.['X3Exp3ImageHref'] ?? ''"
        (handleOnChange)="onChange($event, 'X3Exp3ImageHref')"
        [placeholder]="image3HrefPlaceholder"
        variable="X3Exp3ImageHref"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'X3Exp3ImageHrefSegmentRegex')"
        [selectedSegment]="block.variables?.['X3Exp3ImageHrefSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="alt"
      [blockData]="block.variables?.['X3Exp3ImageAlt'] ?? ''"
      (handleOnChange)="onChange($event, 'X3Exp3ImageAlt')"
      [placeholder]="image3AltPlaceholder"
      [maxLength]="500"
      variable="X3Exp3ImageAlt"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X3Exp3Heading'] ?? ''"
      (handleOnChange)="onChange($event, 'X3Exp3Heading')"
      [placeholder]="heading3Placeholder"
      [maxLength]="500"
      variable="X3Exp3Heading"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <div class="cr-x3-link-field">
      <app-field-editor-v2
        type="action-link"
        [blockData]="block.variables?.['X3Exp3CtaLink'] ?? ''"
        (handleOnChange)="onChange($event, 'X3Exp3CtaLink')"
        [placeholder]="ctaLink3Placeholder"
        [maxLength]="500"
        variable="X3Exp3CtaLink"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'X3Exp3CtaLinkSegmentRegex')"
        [selectedSegment]="block.variables?.['X3Exp3CtaLinkSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X3Exp3CtaText'] ?? ''"
      (handleOnChange)="onChange($event, 'X3Exp3CtaText')"
      [placeholder]="ctaText3Placeholder"
      [maxLength]="30"
      variable="X3Exp3CtaText"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>
</div>
